<app-modal>
  <h5 modal-title>{{ quotaTypeName }} pakket kopen</h5>

  <div modal-body class="pt-3">
    @if (isLoading) {
      <div class="text-center py-4">
        <i class="fas fa-spinner-third fa-spin fa-3x"></i>
      </div>
    }

    <!-- Step 1: Choose package -->
    @if (step === 1 && !isLoading) {
      @if (blocked) {
        <p>
          <i class="fa-solid fa-triangle-exclamation text-danger me-1"></i>
          <strong>Je gratis {{ quotaTypeName | lowercase }} zijn op.</strong><br />
          Koop een pakket om verder te versturen via Peppol, of upgrade je abonnement.
        </p>
      }
      <p>Facturen uit het pakket vervallen niet en kunnen ook in volgende kwartalen gebruikt worden.</p>
      <table class="table table-striped">
        <thead>
          <tr>
            <th>Pakket</th>
            <th class="text-end">Prijs (incl. BTW)</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          @for (pkg of packages; track pkg.Id) {
            <tr>
              <td>{{ pkg.Name }}</td>
              <td class="text-end">&euro; {{ pkg.PurchasePrice! * 1.21 | number:'1.2-2' }}</td>
              <td class="text-end">
                <button class="btn btn-sm btn-success" [disabled]="isLoading" (click)="selectPackage(pkg)">Bestel</button>
              </td>
            </tr>
          }
        </tbody>
      </table>
      <p class="text-muted mt-3 mb-0">
        <i class="fa-solid fa-lightbulb me-1"></i>
        Jullie zijn actief bezig met factureren — met
        <a role="button" class="fw-bold" (click)="upgrade.emit()">Assist START</a>
         verstuur je onbeperkt via Peppol én krijg je er boekhouding en VZW-helper bij.
      </p>
    }

    <!-- Payment result -->
    @if (step === 3 && payment) {
      @if (payment.Succeed) {
        <div class="text-center">
          <div class="mb-4">
            <i class="fas fa-check-circle fa-4x text-success"></i>
          </div>
          <h4 class="text-success mb-3">Betaling succesvol afgerond!</h4>
          <p class="mb-3">
            Je betaling via {{ payment.Method }} van {{ payment.Amount | currency }} is succesvol
            verwerkt. De extra facturen zijn meteen beschikbaar en je kan verder versturen via Peppol.
          </p>
          <p class="text-muted">
            Je ontvangt binnen enkele ogenblikken een bevestigingsmail en de factuur.
          </p>
        </div>
      }
      @if (payment.Canceled) {
        <div class="text-center">
          <div class="mb-4">
            <i class="fas fa-times-circle fa-4x text-warning"></i>
          </div>
          <h4 class="text-warning mb-3">Betaling geannuleerd</h4>
          <p class="mb-3">
            Je hebt de betaling van {{ payment.Amount | currency }} via
            {{ payment.Method }} geannuleerd. Geen probleem, er zijn geen kosten in rekening gebracht.
          </p>
          <p class="text-muted">
            Wil je toch een factuurpakket kopen? Sluit dit venster en probeer het opnieuw.
            Heb je vragen of ondervind je problemen?<br />
            Contacteer dan gerust Vincent via
            <a href="mailto:vincent&#64;assistonline.eu">vincent&#64;assistonline.eu</a>.
          </p>
        </div>
      }
      @if (!payment.Succeed && !payment.Canceled) {
        <div class="text-center">
          <div class="mb-4">
            <i class="fas fa-spinner fa-spin fa-4x text-primary"></i>
          </div>
          <h4 class="text-primary mb-3">Betaling wordt verwerkt...</h4>
          <p class="mb-3">
            We wachten momenteel op de bevestiging van je betaling via {{ payment.Method }} voor een
            bedrag van {{ payment.Amount | currency }}.
          </p>
          <p class="text-muted">
            Dit kan enkele ogenblikken duren, koos je voor overschrijving zelfs enkele dagen.
            Zodra we de bevestiging ontvangen, worden de extra facturen automatisch bijgeschreven.
            Je hoeft deze pagina niet open te houden — je ontvangt een bevestigingsmail zodra alles in orde is.
          </p>
        </div>
      }
    }
  </div>

  <div modal-footer class="right">
    @if (step === 3 && payment?.Succeed) {
      <button class="btn btn-link" (click)="activeModal.close('paid')">Sluiten</button>
    }
    @if (step === 3 && payment?.Canceled) {
      <button class="btn btn-link" (click)="back()">Opnieuw proberen</button>
    }
  </div>
</app-modal>
